import type { FC, ReactNode } from "react";

import {
  MOBILE_OVERLAY_ROUTE_QUERY_PARAM,
  type MobileOverlayRouteType,
} from "components/constants";
import { shouldUseMobileRoutingOverlay } from "components/responsive-overlay-routing";
import { DialogDeferralProvider } from "mds/hooks/use-dialog-presentation";
import { useIsLgOrLarger } from "mds/hooks/use-responsive";
import { useQueryParam } from "utils/routing";

type DialogProviderProps = {
  children: ReactNode;
};

export const DialogProvider: FC<DialogProviderProps> = ({ children }) => {
  const isLgOrLarger = useIsLgOrLarger();
  const selectedOverlayRoute = useQueryParam(
    MOBILE_OVERLAY_ROUTE_QUERY_PARAM,
  ) as MobileOverlayRouteType | null;

  const hasActiveMobileOverlay = shouldUseMobileRoutingOverlay(selectedOverlayRoute, isLgOrLarger);

  return <DialogDeferralProvider value={hasActiveMobileOverlay}>{children}</DialogDeferralProvider>;
};
